/* eslint-disable react-hooks/exhaustive-deps */
import { emailRegex, phoneRegExp, validateEmail } from 'components/helper/appConfig';
import React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import FormHelperText from '@mui/joy/FormHelperText';

interface Props {
  id?: string;
  hidden?: boolean;
  mdCol?: string | number;
  label?: string;
  name: string;
  values: any;
  onChange?: (e: any) => void;
  isValid?: boolean;
  feedback?: any;
  placeholder?: string;
  disabled?: boolean;
  countText?: number;
  type?: string;             // 'text', 'password', 'number', 'phoneNumber',...
  min?: number;
  max?: number;
  className?: string;
  decimalStep?: number;
  form?: any;
  logo?: string;
  otherProps?: any;
  isOverCount?: boolean;
  countWord?: number;
  readOnly?: boolean;
  setLabelHight?: boolean;
  isMissing?: any;
  isCMLogo?: boolean;
  isTestCsuLogo?: boolean;
  isCuScuLogo?: boolean;
  labelClass?: string;
  labelCustom?: any;
}

const TextInput = (props: Props) => {
  const [counter, setCounter] = React.useState(0);
  const [phoneValidation, setPhoneValidation] = React.useState<string | undefined>();
  const [counterWord, setCounterWord] = React.useState(0);
  const [classOverText, setClassOverText] = React.useState('');

  const changeColorOverCount = () => {
    let newClassOverText = '';
    
    // Kiểm tra vượt quá giới hạn ký tự
    if (props.isOverCount && props.countText && (props.values?.length ?? 0) > props.countText) {
      newClassOverText = 'text-danger';
    }

    // Kiểm tra vượt quá giới hạn từ
    if (props.isOverCount && props.countWord && ((props.values || '').split(/\s+/).filter(Boolean).length ?? 0) > props.countWord) {
      newClassOverText = 'text-danger';
    }

    setClassOverText(newClassOverText);
  };

  const getInfo = () => {
    const wordCount = ((props?.type === 'string' && props.values) || '')
      .split(/\s+/)
      .filter(Boolean).length;
    if (props.values?.length && props.countText) {
      setCounter(props.values.length ?? 0);
    } else if (props.countWord) {
      setCounterWord(wordCount ?? 0);
    }
    changeColorOverCount();
  };

  React.useEffect(() => {
    if (props.type === 'phoneNumber' && !phoneRegExp.test(props.values)) {
      setPhoneValidation('Phone number is not valid');
    } else if (props.type === 'email' &&  props.values && (props.values.length>0) && !validateEmail(props.values)) {
      setPhoneValidation('Email is not valid');
    } else {
      setPhoneValidation(undefined);
    }
    getInfo();
  }, [props.values]);

  React.useEffect(() => {
    changeColorOverCount();
  }, []);

  // Thêm useEffect để theo dõi thay đổi của isOverCount
  React.useEffect(() => {
    changeColorOverCount();
  }, [props.isOverCount, props.countText, props.countWord]);

  const handleChange = async (e: any) => {
    if (!props.isOverCount && props.countText && e.target.value.length > props.countText) {
      return;
    }

    const wordCount = (e.target.value || '').split(/\s+/).filter(Boolean).length;
    if (!props.isOverCount && props.countWord && wordCount > props.countWord) return;

    // prevent add more space
    if (!props.isOverCount && props.countWord && wordCount === props.countWord) {
      if (e.target.value[e.target.value.length - 1] === ' ') return;
    }

    props.onChange && props.onChange(e);
    setCounter(e.target.value.length);
  };

  return props.hidden ? null : (
    <FormControl
      id={props.id}
      disabled={props.disabled}
      error={!!props.isMissing || !!phoneValidation || (!!props.max && props.type === 'number' && props.values > props.max) || (!!props.min && props.type === 'number' && props.values < props.min)}
      className={props.className}
    >
      {props.labelCustom!==undefined ? (
      <label htmlFor={props.id || props.name} className = {props.labelClass} >
        {props.label}
        {props.labelCustom && (props.labelCustom)}
      </label>
      ) : (
      <div
        style={
          props.setLabelHight
            ? {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                minHeight: '40px',
                marginBottom: '2px'
              }
            : { marginBottom: '2px' }
        }
      >
        <FormLabel
          className={`select-label label-14px ${props.labelClass}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            margin: props.setLabelHight ? 0 : undefined,
            marginBottom: '1px !important',
            backgroundColor: props.isMissing ? '#FFEBEB' : '',
          }}
        >
          <span>{props.label}</span>
          {(props?.logo && props.setLabelHight) && (
            <FormLabel className={`csu-logo-select-input-float-right ${props?.logo ?? ''}`.trim()} />
          )}
        </FormLabel>
        {(props?.logo && !props.setLabelHight && !props.isTestCsuLogo && !props.isCuScuLogo) ? <span className={`cm-logo-select-input-float-right ${props?.logo ?? null}`}></span> : null}
        {(props?.logo && props.isTestCsuLogo) ? <span className={`csu-logo-sat-text-float-right ${props?.logo ?? null}`}></span> : null}
        {(props?.logo && props.isCuScuLogo) ? <span className={`csu-logo-cu-csu-citizen-right ${props?.logo ?? null}`}></span> : null}
      </div>
      )}
      <Input
        id={props.id}
        className={classOverText}
        sx={{
          fontSize: '15px',
          backgroundColor: '#fff',
          '&.text-danger': {
            '& .MuiInput-input': {
              color: '#d32f2f !important',
            },
            '& .MuiInput-root': {
              borderColor: '#d32f2f !important',
            },
            '&:hover .MuiInput-root': {
              borderColor: '#d32f2f !important',
            },
            '&.Mui-focused .MuiInput-root': {
              borderColor: '#d32f2f !important',
            }
          },
          paddingLeft: '14px',
          paddingRight: '14px',
          paddingInlineStart: '14px',
          paddingInlineEnd: '14px',
          '&.Mui-disabled': {
            color: '#9fa6ad',
          },
          '&.Mui-disabled input.Mui-disabled': {
            color: '#9fa6ad!important', 
          }
        }}
        {...props.otherProps}
        step={props.decimalStep ?? 1}
        min={props.min || 0}
        max={props.max}
        disabled={props.disabled}
        placeholder={props.placeholder}
        type={props.type || 'text'}
        name={props.name}
        value={props.values ?? ''}
        inputProps={{
          maxLength: props.isOverCount ? undefined : props.countText,
          readOnly: props.readOnly,
          onWheel: (e: React.WheelEvent<HTMLInputElement>) => e.currentTarget.blur(),
        }}
        onChange={handleChange}
        color={props.isValid ? 'success' : undefined}
        error={!!props.isMissing || !!phoneValidation || (!!props.max && props.type === 'number' && props.values > props.max) || (!!props.min && props.type === 'number' && props.values < props.min)}
      />
      {(props.feedback ||
        phoneValidation ||
        (!!props.max && props.type === 'number' && props.values > props.max) ||
        (!!props.min && props.type === 'number' && props.values < props.min) ||
        (props.countText && props.type !== 'number') ||
        (props.countWord && props.type !== 'number')) && (
        <FormHelperText sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '1rem' }}>
          <span>
            {props.feedback && <span>{props.feedback}</span>}
            {phoneValidation && <span style={{ color: '#d32f2f' }}>{phoneValidation}</span>}
            {!!props.max && props.type === 'number' && props.values > props.max && (
              <span style={{ color: '#d32f2f' }}>Invalid number</span>
            )}
            {!!props.min && props.type === 'number' && props.values < props.min && (
              <span style={{ color: '#d32f2f' }}>Invalid number</span>
            )}
          </span>
          <span>
            {props.countText && props.type !== 'number' && (
              <span 
                title={`${counter}/${props.countText} characters`}
                style={{
                  color: props.isOverCount && counter > props.countText ? '#d32f2f' : 'inherit'
                }}
              >
                {counter}/{props.countText} characters
              </span>
            )}
            {props.countWord && props.type !== 'number' && (
              <span 
                title={`${counterWord}/${props.countWord} words`}
                style={{
                  color: props.isOverCount && counterWord > props.countWord ? '#d32f2f' : 'inherit'
                }}
              >
                {counterWord}/{props.countWord} words
              </span>
            )}
          </span>
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default TextInput;
